<template>
  <a :href="'https://data.europa.eu' + path"
    class="dataset-info-box text-dark text-decoration-none mt-3">
    <div class="d-flex justify-content-between w-100">
      <span class="editorial-content-kind">{{ kind }} </span>
      <div class="scope-badge"> Editorial content</div>
    </div>
    <div class="editorial-content-info-box-body">
      <div class="row">
        <div v-if="thumbnail" class="editorial-content-thumbnail">
          <img :src="thumbnail" :alt="kind">
        </div>
        <div
          class="dataset-info-box-description-container col-12 col-md"
          data-cy="dataset-description"
        >
          <div data-cy="editorial-content-title" class="mt-3">
            <h2 class="card-title">{{ title }}</h2>
          </div>
          <div v-if="description" data-cy="editorial-content-description" class="mt-3">
            <p class="description">{{ description }}</p>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import {computed, defineProps} from "vue";
import {helpers} from "@piveau/piveau-hub-ui-modules";
import {useRoute} from "vue-router";
import { getEditorialThumbnailOrFlag } from "@/utils/editorialContentThumbnail";
const { getTranslationFor, getCountryFlagImg } = helpers;

const locale = useRoute().query.locale;

const props = defineProps({
  item: Object,
  scope: String
});
let {
  title,
  description,
  path,
  thumbnail,
  content_type
} = props.item;

title = getTranslationFor(title, locale, ["en"]);
description = getTranslationFor(description, locale, ["en"]);


if (thumbnail && typeof thumbnail === "string") {
  thumbnail = thumbnail.replace(/^https:\/\/drupal\.agiledrop\.svc/, "");
}

thumbnail = getEditorialThumbnailOrFlag({
  thumbnail,
  path,
  content_type,
}, getCountryFlagImg);

const maxLength = 240;
const descriptionTruncated = description?.length > maxLength;
description = descriptionTruncated ? `${description.slice(0, maxLength)} ...` : description;

const kind = computed(() => {
  switch(content_type) {
    case "factsheets_reports": return "Reports";
    case "covid_19_data_stories": return "COVID-19 Data Stories";
    case "use_cases": return "Use Cases";
    case "lesson":  return "Academy - lesson";
    case "course":  return "Acedemy - course"; 
    case "data_stories":  return "Data Stories"; 
    case "country_insight":  return "Country Insight"; 
    default: return content_type.slice(0,1).toUpperCase() + content_type.slice(1);
  }
});

</script>

<style scoped lang="scss">
.editorial-content-info-box-body {
  min-height: initial;
  /*padding-top: 1rem;*/
  padding: 1.25rem;
}

.scope-badge {
  border-radius: 4px;
  background-color: #eee;
  padding: 0 0.5rem;
  font-size: 14px;
}

.editorial-content-thumbnail {
  margin-right: 1rem;
  margin-left: 1rem;
  width: 110px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background-color: #eee;
  overflow: hidden;

  img {
    height: 100%;
  }
}

.description {
  max-height: 100px;
  overflow: hidden;
}

.editorial-content-kind {
  font-size: small;
  padding-left: 1.25rem;
}

</style>
